import { Outside } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import { Checkbox } from '../Checkbox';
import React, { useCallback, useState, FC } from 'react';
import { EOfferType } from '../../utils/jsonQuery';
import stylesCommon from '../FiltersPanel/FiltersPanel.css';
import styles from './FilterOfferType.css';
import { IOfferType } from '../../types/offerTypeList';

export interface IFilterOfferTypeProps {
  label: string | null;
  list: IOfferType[][];
  offerType: EOfferType;
  onSelect(offerType: EOfferType): void;
}

export interface IFilterOfferTypeState {
  active: boolean;
}

export const FilterOfferType: FC<IFilterOfferTypeProps> = ({ offerType, label, list, onSelect }) => {
  const [active, setActive] = useState(false);

  const handleButtonClick = useCallback(() => {
    setActive(!active);
  }, [active]);

  const handleOutsideClick = useCallback(() => {
    setActive(false);
  }, []);

  const handleChangeOfferType = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>): void => {
      const selectedOfferType: EOfferType = Number(e.currentTarget.value);

      if (offerType === selectedOfferType) {
        return;
      }

      onSelect(selectedOfferType);
    },
    [offerType, onSelect],
  );

  return (
    <Outside onOutside={handleOutsideClick}>
      <div
        {...mergeStyles(stylesCommon['container'], styles['container'])}
        data-mark="FilterOfferType"
        data-name="FilterOfferType"
      >
        <button
          {...mergeStyles(stylesCommon['button'], active ? stylesCommon['button--active'] : undefined)}
          title={label || undefined}
          onClick={handleButtonClick}
        >
          {label}
        </button>
        {active && (
          <div className={styles['dropdown']}>
            <ul className={styles['list']}>
              {list.map((part, index) => (
                <li key={`part_${index}`}>
                  <ul className={styles['list-inner']}>
                    {part.map(item => (
                      <li key={`item_${item.label}`}>
                        <Checkbox
                          label={item.label}
                          value={item.value}
                          checked={(offerType & item.value) !== 0}
                          onChange={handleChangeOfferType}
                        />
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Outside>
  );
};
